import React, { Fragment, useCallback, useMemo, useState } from 'react';
import InputField from './InputField/InputField';
import * as S from './styles';
import SubmitButton from './SubmitButton/SubmitButton';

declare interface CustomFormProps {
  status: 'sending' | 'success' | 'error' | null;
  message: string | Error | null;
  onValidated: (data: any) => void;
}

const SuccessMessage = () => (
  <Fragment>
    <S.Title>Sucesso. Parabéns por esse passo!</S.Title>
    <p>Enviaremos para seu email as informações sobre o ACE.</p>
    <p>Por favor, caso não localize o email procure na pasta de spam.</p>
    <p>O título do email que chegará em instantes é <strong>"ACE 1/5: Sua vida é mesmo tão corrida como você diz que é?".</strong></p>
  </Fragment>
);

const CustomForm = ({ status, message, onValidated }: CustomFormProps) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    email &&
    firstName &&
    lastName &&
    email.indexOf("@") > -1 &&
    phone &&
    onValidated({
      EMAIL: email,
      MERGE1: firstName,
      MERGE2: lastName,
      MERGE3: phone,
    });
  }, [email, firstName, lastName, phone, onValidated]);

  const parsedMessage = useMemo(() => {
    if (!status) {
      return null;
    }

    if (status === 'sending') {
      return 'Enviando...';
    } else if (status === 'error') {
      if (typeof message === 'string' && /is already subscribed/.test(message)) {
        return 'Este email já está registrado';
      }

      return 'Desculpe-nos. Ocorreu um erro! Tente novamente mais tarde.';
    }

    return null;
  }, [status, message]);

  if (status === 'success') return <SuccessMessage />;

  return (
      <form onSubmit={(e) => handleSubmit(e)}>
        <S.Title>Deixe seu nome, telefone e e-mail que vamos te enviar todas as informações:</S.Title>

        <div>
          {parsedMessage}
        </div>

        <InputField
          label="Nome"
          onChange={setFirstName}
          type="text"
          value={firstName}
          required
        />

        <InputField
          label="Sobrenome"
          onChange={setLastName}
          type="text"
          value={lastName}
          required
        />

        <InputField
          label="Email"
          onChange={setEmail}
          type="email"
          value={email}
          required
        />

        <InputField
          label="Telefone"
          onChange={setPhone}
          type="phone"
          value={phone}
          required
        />

        <SubmitButton />
      </form>
    );
};

export default CustomForm;
